import { createLoadingReducer } from './utils';

export default createLoadingReducer<any>('VERIFY_EMAIL');
